'use client'

import {
	MapDispatchContext,
	type MapDispatchContextType,
} from 'maps/contexts/MapProvider'
import { useContext } from 'react'

/** @throws {Error} If useMapDispatch is used without MapProvider */
export function useMapDispatch(): MapDispatchContextType {
	const context = useContext(MapDispatchContext)

	if (context === undefined) {
		throw new Error('useMapDispatch must be used within a MapStoresProvider')
	}

	return context
}
